module.exports = __webpack_public_path__ + "img/icon-play.81d94531.svg";